import { Capacitor } from "@capacitor/core";

export const isCapacitorIos = Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";
export const isCapacitorAndroid =
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";
export const isCapacitor = Capacitor.isNativePlatform();
